import _ from 'lodash'

// Initials shown in avatars and badges, for user names as well as brand names.
export const getAvatarInitials = (name: string, initialsCount: number = 1) =>
  _(name).words().invokeMap('at', 0).take(initialsCount).join('').toUpperCase()
